import type { DistanceTripDetail, DistanceTripItem, DistanceTripsQuery, Page, ResolveDistanceGapInput, TruckDistanceGaps } from '@chukua/common';
import { api } from '../../shared/shared.api';
import { toListParams } from '../../shared/policies/list-params';

export type { DistanceTripDetail, DistanceTripItem, TruckDistanceGaps };

export function listDistanceTrips(query: DistanceTripsQuery): Promise<Page<DistanceTripItem>> {
  return api<Page<DistanceTripItem>>(`/distance-agreement/trips?${toListParams(query)}`);
}

export function getDistanceTrip(tripId: string): Promise<DistanceTripDetail> {
  return api<DistanceTripDetail>(`/distance-agreement/trips/${tripId}`);
}

export function getTruckDistanceGaps(truckId: string): Promise<TruckDistanceGaps> {
  return api<TruckDistanceGaps>(`/distance-agreement/trucks/${truckId}`);
}

/** Answers with the comparison as it now stands. */
export function resolveDistanceGap(tripId: string, input: ResolveDistanceGapInput): Promise<DistanceTripDetail> {
  return api<DistanceTripDetail>(`/distance-agreement/trips/${tripId}/resolutions`, { method: 'POST', body: JSON.stringify(input) });
}
